import {z} from 'zod';
import {organizationIdSchema, userIdSchema, type OrganizationId, type UserId} from '../domain/id';
import {localeSchema} from '../domain/locale';
import {roleSchema} from '../domain/role';

/**
 * The authenticated caller, resolved from the JWT and the database on every request.
 * Also the response body of `GET /api/me`, which is why it is a schema and not just a type.
 */
export const principalSchema = z.object({
  id: userIdSchema,
  email: z.email(),
  name: z.string(),
  role: roleSchema,
  organizationId: organizationIdSchema.nullable(),
  /** Drives both the interface the user sees and the language we write to them in. */
  locale: localeSchema,
});

export type Principal = z.infer<typeof principalSchema>;

/** The user an action is aimed at. Only the fields the policy actually reasons about. */
export interface UserTarget {
  id: UserId;
  role: z.infer<typeof roleSchema>;
  organizationId: OrganizationId | null;
}
